import React from 'react';

import useVehicleTypeSelectable from 'core/hooks/useVehicleTypeSelectable';
import { VehicleType as Type } from 'core/types/vehicleType';

type Props = {
  id: Type['id'];
};

export default function VehicleType({ id }: Props) {
  const types = useVehicleTypeSelectable();

  if (types.length === 0) {
    return <>Ladataan...</>;
  }

  const type = types.find(type => type.id === id);

  return <>{type ? type.label : 'Tuntematon tyyppi'}</>;
}
